import { isNonEmpty } from '@sgme/fp';
import { ColTypeDef, ICellEditorParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { useMemo } from 'react';
import { LabelCellRenderer } from 'routes/secondary-market-batch/grid/components/label-cell-renderer';
import { equalsById } from 'routes/secondary-market-batch/grid/utils/equals-by-id';
import { Sales } from 'state/secondaryMarket/shared/referential/referential.model';
import { RowData } from 'state/workspaces/secondary-market/batch/model';
const formatSale = (sale: Sales | undefined | null): string | undefined =>
  sale ? [sale.country, sale.firstName].join('/') : undefined;

export function useSalesColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(
    () => ({
      cellEditor: 'agRichSelectCellEditor',
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      filterValueGetter: ({ getValue, colDef }: ValueGetterParams<RowData>) => {
        const sales = colDef.field ? getValue(colDef.field) : (undefined as Sales | undefined);
        return formatSale(sales) ?? '';
      },
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
        const sales = value as Sales | undefined;
        return formatSale(sales) ?? '';
      },
      equals: equalsById,
      cellRenderer: LabelCellRenderer,
      cellEditorParams: {
        multiSelect: false,
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        values: ({ colDef, data }: ICellEditorParams<RowData, Sales>) => {
          const sales = data.metadata[colDef.context.metadataId] as Sales[] | undefined;
          return sales?.filter(s => isNonEmpty(s.country) && isNonEmpty(s.firstName)) ?? [];
        },
        formatValue: formatSale,
      },
    }),
    [],
  );
}
